export default __webpack_public_path__ + "static/media/willow_walks.79b45a31.svg";